<template>
    <div>
        <b-modal
            id="serial_modal"
            modal-class="modal-serial"
            centered
            hide-header
            hide-footer
            no-close-on-backdrop
            no-close-on-esc
        >
            <div class="modal-base">
                <div
                    @click="closeSerialModal()"
                    class="text-right"
                    style="margin-top: 0px; margin-right: 0px; color: #544437"
                >
                    <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="21"
                        height="21"
                        viewBox="0 0 21 21"
                        fill="none"
                    >
                        <path
                            d="m11.442 10.275 8.577-8.577A.833.833 0 0 0 18.841.519l-8.578 8.578L1.686.519A.833.833 0 0 0 .507 1.698l8.578 8.577-8.578 8.578a.833.833 0 0 0 1.179 1.178l8.577-8.577 8.578 8.577a.833.833 0 0 0 1.178-1.178l-8.577-8.578z"
                            fill="#000"
                        />
                    </svg>
                </div>
                <div class="modal-base-head">
                    <SerialHeader :serialModel="serial" />
                </div>
                <!--Show code-->
                <div class="modal-base-body">
                    <div
                        class="serial-block"
                        style="min-height: 33vh"
                        v-if="objSerialCode.isShowCode && campaign.serial"
                    >
                        <div
                            class="serial-wrapper serial-tab-wrapper"
                            style="white-space: inherit"
                        >
                            <div
                                class="serial-tab"
                                @click="clickChangeTab('QR_CODE')"
                            >
                                <div
                                    class="serial-tab-lbl"
                                    :class="{
                                        'tab-active':
                                            objSerialCode.strCodeType ===
                                            'QR_CODE',
                                    }"
                                >
                                    <div class="serial-lbl">QR Code</div>
                                </div>
                            </div>
                            <div
                                class="serial-tab"
                                @click="clickChangeTab('CODE_128')"
                            >
                                <div
                                    class="serial-tab-lbl"
                                    :class="{
                                        'tab-active':
                                            objSerialCode.strCodeType ===
                                            'CODE_128',
                                    }"
                                >
                                    <div class="serial-lbl">Bar Code</div>
                                </div>
                            </div>
                            <div
                                class="serial-tab"
                                @click="clickChangeTab('CODE')"
                            >
                                <div
                                    class="serial-tab-lbl"
                                    :class="{
                                        'tab-active':
                                            objSerialCode.strCodeType ===
                                            'CODE',
                                    }"
                                >
                                    <div class="serial-lbl">Code</div>
                                </div>
                            </div>
                        </div>

                        <div id="serial_code_wrapper" class="serial-wrapper">
                            <div id="show_code_lbl">
                                โปรดแสดงรหัสนี้แก่พนักงาน
                            </div>
                            <div
                                id="code_wrapper"
                                class="serial-code"
                                v-show="objSerialCode.strCodeType === 'CODE'"
                            >
                                <p
                                    id="code"
                                    :class="{
                                        'long-code':
                                            campaign.serial.length > 12,
                                        'serial-expire':
                                            campaign.serial === 'XXXXXXX',
                                    }"
                                >
                                    {{
                                        campaign.serial === "XXXXXXX"
                                            ? "XXXXXXX"
                                            : campaign.serial
                                    }}
                                </p>
                                <div id="copy_code_btn" class="btn-wrapper">
                                    <div
                                        class="btn-txt"
                                        v-clipboard:copy="campaign.serial"
                                        v-clipboard:success="onCopyCode"
                                        v-clipboard:error="onErrorCode"
                                    >
                                        Copy
                                    </div>
                                </div>
                            </div>
                            <div
                                class="serial-code"
                                v-show="
                                    objSerialCode.strCodeType === 'CODE_128'
                                "
                            >
                                <vue-barcode
                                    id="barcode"
                                    :value="campaign.serial"
                                    :options="barcodeConfig"
                                ></vue-barcode>
                            </div>
                            <div
                                class="serial-code"
                                v-show="objSerialCode.strCodeType === 'QR_CODE'"
                            >
                                <vue-qrcode
                                    id="qrcode"
                                    :value="campaign.serial"
                                    :options="objQrCodeConfig"
                                ></vue-qrcode>
                            </div>
                        </div>
                        <div
                            class="serial-block"
                            v-if="!objSerialCode.isShowCode"
                        >
                            <div class="serial-wrapper">
                                <p
                                    class="serial-privilege-message"
                                    v-html="
                                        cleanMessage(
                                            objSerialMessage.strMessage
                                        )
                                    "
                                ></p>
                            </div>
                        </div>
                    </div>
                    <div class="modal-base-footer">
                        <div class="serial-block">
                            <div class="serial-wrapper">
                                <div id="serial_redeem_on">
                                    ใช้เมื่อ
                                    {{ getRedeemDate(campaign.redeemDate) }}
                                </div>
                            </div>
                            <div
                                class="serial-wrapper"
                                v-if="objTimer.isShowTimer"
                            >
                                <div id="serial_expire">
                                    <span
                                        id="serial_expire_txt"
                                        v-if="!objTimer.isExpired"
                                    >
                                        รหัสหมดอายุภายใน
                                    </span>
                                    <span id="serial_expire_time">
                                        {{ objTimer.strTimeLeft }}
                                    </span>
                                    <span
                                        id="serial_expire_time"
                                        v-if="objTimer.isExpired"
                                        >รหัสหมดอายุ
                                    </span>
                                </div>
                            </div>
                            <div class="serial-logo">
                                <svg
                                    xmlns="http://www.w3.org/2000/svg"
                                    width="66"
                                    height="36"
                                    viewBox="0 0 66 36"
                                    fill="none"
                                >
                                    <g clip-path="url(#6fss7756wa)">
                                        <path
                                            d="M66 16.415c0 .505-.394.883-.899.883-.504 0-.914-.394-.914-.883s.41-.883.914-.883c.49 0 .899.394.899.883zm-1.593 0c0 .395.3.694.678.694.379.016.678-.315.678-.694 0-.394-.3-.71-.678-.71-.378 0-.677.332-.677.71zm.552.457h-.205v-.883c.08 0 .19-.031.331-.031.158 0 .237.031.3.079.047.031.079.094.079.189 0 .11-.079.174-.19.205.08.032.127.095.158.22.032.127.048.174.063.206h-.22c-.032-.032-.048-.11-.063-.205-.016-.095-.08-.142-.19-.142h-.063v.362zm0-.488h.095c.11 0 .205-.032.205-.126 0-.08-.063-.127-.19-.127-.047 0-.078 0-.11.016v.237z"
                                            fill="#000"
                                        />
                                        <path
                                            d="M59.567 1.987c-.173 1.072-.552 2.097-1.387 2.964-.395.41-.978.836-1.514 1.01h1.167c2.144 0 3.2-.332 3.926-1.088 1.308-1.372 1.293-2.855 1.576-4.889h-1.97c-.52.016-1.483.048-1.798 2.003z"
                                            fill="#E30613"
                                        />
                                        <path
                                            d="M43.485 7.585h-3.011c-1.262 2.286-2.27 5.755-3.107 9.934h2.334c.079-.6.19-1.214.331-1.876h3.406a35.3 35.3 0 0 1 .362 1.876h2.87c-.788-3.611-2.034-7.648-3.185-9.934zm-3.106 6.386a30.5 30.5 0 0 1 1.277-3.958c.552 1.12.993 2.507 1.372 3.958h-2.65z"
                                            fill="#000"
                                        />
                                        <path
                                            d="M51.353 5.96h-40.38v11.386c-.204.126-.898.189-1.371.189-2.207 0-2.87-1.546-3.043-1.86L2.444 8.073v9.445H0V4.21c.284-.126.899-.189 1.372-.189 1.608 0 2.191.41 3.043 1.94l4.146 7.726V4.116h46.213c0 1.198-1.94 1.845-3.421 1.845zM60.781 15.848c-1.009 0-1.624-.08-1.94-.537-.267-.394-.299-1.088-.299-1.86h3.816v-1.877h-3.816V9.461h4.43V7.585H55.91v5.913c0 1.403.22 2.633.82 3.233.757.74 2.066 1.009 3.8 1.009.914 0 1.892-.142 2.491-.442v-1.766a7.838 7.838 0 0 1-2.239.316z"
                                            fill="#000"
                                        />
                                        <path
                                            d="M15.656 15.311c-.268-.394-.3-1.088-.3-1.86h3.832v-1.877h-3.831V9.461h4.43V7.585h-7.063v5.913c0 1.403.22 2.633.82 3.233.756.74 2.065 1.009 3.8 1.009.914 0 1.876-.142 2.49-.442v-1.766a7.838 7.838 0 0 1-2.238.316c-1.01 0-1.624-.08-1.94-.537zM23.414 9.966c.142-.694.835-.726 1.53-.726 1.056 0 1.939.19 2.853.458V7.9c-.426-.252-1.482-.568-2.98-.568-1.198 0-2.35.174-3.185.962-.773.741-.946 3.296-.079 4.195.63.662 2.003 1.025 3.059 1.387.426.142 1.277.347 1.246 1.073-.048.914-.836.899-1.53.899-1.056 0-2.097-.205-3.058-.49v1.83c.488.268 1.497.536 3.105.536 1.104 0 2.429-.205 3.217-.804 1.009-.789 1.183-3.201.252-4.29-.646-.74-2.302-1.087-3.405-1.545-.678-.252-1.183-.362-1.025-1.12zM32.78 15.327c-.3-.441-.38-1.356-.38-2.79 0-1.436.08-2.319.38-2.792.267-.426.977-.52 1.702-.52.678 0 1.309.079 1.987.315V7.774c-.552-.268-1.404-.426-2.176-.426-1.45 0-2.917.205-3.721 1.04-.757.774-1.01 2.43-1.01 4.164 0 1.719.253 3.359 1.01 4.147.804.852 2.255 1.057 3.72 1.057.726 0 1.483-.095 1.987-.363l.395-1.845c-.741.236-1.372.315-2.208.315-.71-.015-1.419-.11-1.687-.536zM47.632 16.1c0 1.45 1.23 1.64 2.648 1.64v-4.29h4.053v-1.876H50.28V9.461h4.43V7.585h-7.078V16.1zM17.501 23.038c.079.047.126.095.142.142.032.047.032.11.032.158a.32.32 0 0 1-.095.236.333.333 0 0 1-.252.095c-.063 0-.174-.016-.331-.063-.158-.032-.3-.063-.426-.063a2.715 2.715 0 0 0-1.34.362c-.19.127-.363.268-.473.458a1.1 1.1 0 0 0-.19.63c0 .142.064.284.206.442.141.158.3.315.504.473.205.173.426.331.662.52.237.174.458.363.662.568.206.19.363.394.505.6.142.204.205.425.205.646 0 .347-.079.662-.252.93a2.518 2.518 0 0 1-.662.694c-.268.19-.568.363-.9.489-.33.126-.661.236-.992.33a7.862 7.862 0 0 1-.93.174c-.285.032-.521.048-.71.048-.19 0-.394-.016-.615-.032a3.56 3.56 0 0 1-.615-.11 1.645 1.645 0 0 1-.473-.19c-.126-.078-.19-.173-.19-.283 0-.063.032-.142.08-.205.047-.063.126-.11.252-.11s.236.015.33.062c.206.063.41.11.632.142.205.032.41.032.615.032.378 0 .772-.047 1.214-.126a7.01 7.01 0 0 0 1.23-.379 3.2 3.2 0 0 0 .945-.63c.253-.253.379-.52.379-.836 0-.142-.063-.3-.205-.457a3.699 3.699 0 0 0-.505-.474c-.205-.157-.425-.33-.662-.504a5.699 5.699 0 0 1-.662-.568 2.916 2.916 0 0 1-.505-.6 1.132 1.132 0 0 1-.205-.661c0-.316.08-.6.237-.868.157-.252.362-.473.63-.646.253-.174.552-.316.883-.41a3.77 3.77 0 0 1 1.041-.142c.142 0 .284.016.442.032a.836.836 0 0 1 .346.094h.016zM21.947 26.113c.016.032.016.063.016.11a.246.246 0 0 1-.126.205.884.884 0 0 1-.347.142 3.797 3.797 0 0 1-.504.08c-.19.015-.41.03-.631.03h-.378c-.158.316-.3.631-.442.931-.126.3-.252.6-.347.867-.094.284-.173.537-.236.773a2.452 2.452 0 0 0-.095.63c0 .143.032.269.095.348a.588.588 0 0 1 .079.236.32.32 0 0 1-.331.331.254.254 0 0 1-.206-.094.534.534 0 0 1-.141-.221c-.032-.095-.064-.19-.095-.3-.016-.11-.031-.205-.031-.315 0-.22.031-.457.094-.71.063-.252.142-.52.237-.804a9.44 9.44 0 0 1 .33-.851c.127-.284.253-.584.38-.868h-.285c-.268 0-.457-.015-.583-.047-.126-.031-.19-.126-.19-.284 0-.094.032-.189.095-.252a.321.321 0 0 1 .237-.095c.173.016.33.016.504.016h.568c.142-.284.284-.552.426-.788.126-.253.252-.458.362-.647.11-.19.221-.331.3-.426.095-.11.173-.157.22-.157a.32.32 0 0 1 .332.33c0 .064-.016.111-.063.174-.142.237-.284.49-.442.741-.142.268-.3.52-.441.789h.473c.126 0 .236-.016.33-.016.095-.016.174-.016.253-.031.079-.016.158-.016.252-.032.063 0 .127.016.19.032.078.047.126.094.141.173zM22.168 26.365c.079-.142.19-.22.331-.22.08 0 .142.031.205.094a.287.287 0 0 1 .095.22.46.46 0 0 1-.032.143 78.61 78.61 0 0 1-.047.142c-.063.142-.11.268-.142.362-.047.11-.079.205-.126.316-.047.11-.095.22-.142.347-.047.126-.126.268-.19.441.206-.22.395-.441.6-.646.205-.205.41-.395.6-.568.188-.158.378-.284.567-.378.189-.095.362-.142.52-.142.126 0 .252.031.347.11a.844.844 0 0 1 .236.237c.064.094.11.173.142.268.032.094.048.142.048.173a.321.321 0 0 1-.331.331c-.08 0-.142-.031-.174-.079-.031-.047-.079-.11-.11-.157a1.37 1.37 0 0 0-.095-.158.165.165 0 0 0-.142-.079c-.142 0-.347.11-.599.331-.268.221-.552.505-.851.836-.3.331-.615.71-.915 1.104-.3.394-.552.773-.74 1.12-.048.063-.095.11-.143.157a.263.263 0 0 1-.173.063c-.095 0-.174-.031-.22-.094a.32.32 0 0 1-.096-.237c0-.031.032-.126.095-.3.063-.173.158-.394.252-.662.11-.268.221-.552.347-.851l.379-.9c.126-.283.236-.551.33-.788a1.76 1.76 0 0 1 .174-.536zM27.734 26.145c.19 0 .331.031.426.094.11.063.189.126.236.205a.554.554 0 0 1 .095.252c.015.095.015.158.015.221 0 .221-.078.442-.252.694a2.992 2.992 0 0 1-.662.678 5.218 5.218 0 0 1-.915.552 3.508 3.508 0 0 1-1.009.3c-.015.031-.015.078-.015.142 0 .063.015.141.031.22a.583.583 0 0 0 .11.221.67.67 0 0 0 .19.174.518.518 0 0 0 .268.063c.362 0 .74-.095 1.135-.3.378-.205.757-.426 1.088-.694.347-.268.646-.536.899-.804a8.19 8.19 0 0 0 .583-.63c.063-.08.126-.143.19-.222.062-.063.125-.11.204-.11.095 0 .158.032.19.095.03.063.062.126.062.189 0 .047 0 .079-.015.095-.016.031-.032.063-.063.094a8.68 8.68 0 0 1-1.072 1.198 9.403 9.403 0 0 1-1.151.915 6.313 6.313 0 0 1-1.088.6c-.347.141-.647.204-.9.204-.267 0-.488-.047-.646-.142a1.452 1.452 0 0 1-.41-.33 1.18 1.18 0 0 1-.204-.427c-.032-.157-.064-.3-.064-.425 0-.363.048-.678.142-.962.095-.284.221-.536.394-.773.158-.22.332-.426.537-.599.205-.174.394-.3.583-.41.19-.11.378-.205.536-.268.174-.063.3-.095.41-.126l.142.015zM26.472 27.5c-.11.11-.236.252-.362.41-.126.157-.22.346-.315.536a3.89 3.89 0 0 0 .693-.268c.253-.11.473-.253.678-.394.205-.142.379-.3.505-.442.126-.158.205-.3.205-.426 0-.079-.032-.126-.095-.126-.094 0-.252.047-.504.158-.253.126-.52.3-.805.552z"
                                            fill="#000"
                                        />
                                        <path
                                            d="M32.117 26.145c.19 0 .331.031.426.094a.62.62 0 0 1 .236.205.554.554 0 0 1 .095.252c.016.095.016.158.016.221 0 .221-.08.442-.253.694a2.992 2.992 0 0 1-.662.678 5.218 5.218 0 0 1-.914.552 3.508 3.508 0 0 1-1.01.3c-.015.031-.015.078-.015.142 0 .063.016.141.031.22a.581.581 0 0 0 .11.221c.048.063.111.126.19.174a.519.519 0 0 0 .268.063c.363 0 .741-.095 1.135-.3.379-.205.757-.426 1.088-.694.347-.268.647-.536.899-.804.268-.268.457-.473.583-.63.063-.08.126-.143.19-.222.063-.063.126-.11.204-.11.095 0 .158.032.19.095a.449.449 0 0 1 .063.189c0 .047 0 .079-.016.095-.016.031-.032.063-.063.094a8.675 8.675 0 0 1-1.072 1.198 9.395 9.395 0 0 1-1.151.915 6.313 6.313 0 0 1-1.088.6c-.347.141-.647.204-.899.204-.268 0-.489-.047-.646-.142a1.45 1.45 0 0 1-.41-.33 1.18 1.18 0 0 1-.205-.427c-.032-.157-.063-.3-.063-.425 0-.363.047-.678.142-.962.094-.284.22-.536.394-.773.157-.22.33-.426.536-.599.205-.174.394-.3.583-.41.19-.11.378-.205.536-.268.174-.063.3-.095.41-.126l.142.015zM30.856 27.5c-.11.11-.237.252-.363.41a2.99 2.99 0 0 0-.315.536c.22-.063.441-.142.694-.268a4.03 4.03 0 0 0 .677-.394c.205-.142.379-.3.505-.442.126-.158.205-.3.205-.426 0-.079-.032-.126-.095-.126-.094 0-.252.047-.504.158-.253.126-.505.3-.804.552z"
                                            fill="#000"
                                        />
                                        <path
                                            d="M37.493 26.113c.016.032.016.063.016.11a.246.246 0 0 1-.126.205.884.884 0 0 1-.347.142 3.797 3.797 0 0 1-.504.08c-.19.015-.41.03-.63.03h-.38c-.157.316-.299.631-.44.931-.127.3-.253.6-.348.867-.094.284-.173.537-.236.773a2.452 2.452 0 0 0-.095.63c0 .143.032.269.095.348a.59.59 0 0 1 .079.236.321.321 0 0 1-.331.331.254.254 0 0 1-.205-.094.534.534 0 0 1-.142-.221c-.032-.095-.063-.19-.095-.3-.016-.11-.031-.205-.031-.315 0-.22.031-.457.094-.71.063-.252.142-.52.237-.804a9.44 9.44 0 0 1 .33-.851c.127-.284.253-.584.38-.868h-.285c-.268 0-.457-.015-.583-.047-.126-.031-.19-.126-.19-.284 0-.094.032-.189.095-.252a.321.321 0 0 1 .237-.095c.173.016.331.016.504.016h.568c.142-.284.284-.552.426-.788.126-.253.252-.458.362-.647.11-.19.221-.331.3-.426.095-.11.173-.157.22-.157a.32.32 0 0 1 .332.33c0 .064-.016.111-.063.174-.142.237-.284.49-.442.741-.142.268-.3.52-.441.789h.473c.126 0 .236-.016.33-.016.096-.016.174-.016.253-.031.079-.016.158-.016.252-.032.063 0 .127.016.19.032.063.047.11.094.142.173zM42.082 24.489c.268-.253.536-.473.835-.678.284-.205.568-.363.852-.505.284-.142.552-.252.804-.331.268-.079.504-.11.71-.11.378 0 .693.094.93.3.236.189.362.457.362.772 0 .063-.016.158-.047.268-.032.11-.063.22-.126.331-.047.11-.126.205-.19.284-.078.079-.157.126-.267.126a.32.32 0 0 1-.237-.095.286.286 0 0 1-.094-.22.2.2 0 0 1 .015-.095l.048-.095a.879.879 0 0 0 .142-.267.53.53 0 0 0 .063-.237c0-.268-.205-.41-.615-.41-.142 0-.316.031-.52.095a5.445 5.445 0 0 0-.679.268 5.82 5.82 0 0 0-.772.457c-.268.19-.52.394-.789.63a7.575 7.575 0 0 0-.599.616 5.34 5.34 0 0 0-.63.867 7.26 7.26 0 0 0-.505 1.056 3.335 3.335 0 0 0-.205 1.183c0 .489.126.852.379 1.104.252.252.646.394 1.166.394.331 0 .647-.031.946-.095.3-.063.552-.141.789-.22.236-.08.425-.158.567-.237.142-.079.252-.126.3-.157.063-.032.11-.064.157-.095a.284.284 0 0 1 .174-.047c.11 0 .205.031.252.11.047.079.079.142.079.205a.318.318 0 0 1-.047.173.31.31 0 0 1-.142.142c-.032.032-.142.08-.3.174-.173.094-.394.189-.662.3-.268.11-.583.204-.946.283a5.103 5.103 0 0 1-1.135.126c-.694 0-1.246-.189-1.656-.567-.41-.379-.615-.9-.615-1.593 0-.505.08-.978.237-1.42.158-.44.347-.835.568-1.198.22-.362.457-.678.709-.946.284-.236.505-.473.694-.646zM45.66 29.566c0-.189.048-.41.143-.646.094-.237.22-.489.378-.741a5.89 5.89 0 0 1 .552-.726 4.99 4.99 0 0 1 .662-.63c.237-.19.473-.332.694-.442a1.6 1.6 0 0 1 .678-.173c.094 0 .205.015.3.063.094.031.173.094.252.142.063.063.126.126.173.205a.394.394 0 0 1 .063.22.305.305 0 0 1-.094.205.336.336 0 0 1-.237.11.254.254 0 0 1-.142-.047c-.047-.031-.079-.063-.11-.094-.032-.032-.063-.063-.11-.095a.18.18 0 0 0-.127-.047c-.236 0-.504.095-.772.3a4.18 4.18 0 0 0-.773.725 5.136 5.136 0 0 0-.599.883c-.158.3-.236.568-.236.788 0 .048.015.095.031.158s.047.095.11.095c.095 0 .221-.063.395-.205.173-.142.362-.316.567-.537.205-.22.426-.473.647-.756.22-.284.441-.568.646-.868.079-.094.158-.142.268-.142a.3.3 0 0 1 .205.08.246.246 0 0 1 .095.189v.078c0 .032-.016.063-.032.095a5.583 5.583 0 0 0-.252.536c-.079.19-.142.363-.205.536-.063.174-.11.316-.142.442-.032.126-.063.22-.063.284 0 .189.079.268.236.268.127 0 .316-.095.568-.268a6.72 6.72 0 0 0 .773-.647c.268-.252.52-.52.756-.804.237-.284.426-.52.568-.71l.032-.047a.3.3 0 0 1 .236-.126c.079 0 .142.031.174.094.047.064.063.11.063.158 0 .095-.032.174-.095.22a3.012 3.012 0 0 0-.173.237c-.11.142-.253.316-.41.52a10.36 10.36 0 0 1-.6.663c-.22.237-.457.457-.693.647a4.919 4.919 0 0 1-.71.504c-.236.126-.457.205-.646.205-.174 0-.316-.031-.41-.094a.49.49 0 0 1-.205-.237 1 1 0 0 1-.095-.284c-.016-.094-.016-.173-.016-.236s0-.127.016-.158c-.11.142-.236.268-.378.394a3.78 3.78 0 0 1-.41.331 2.611 2.611 0 0 1-.394.237.774.774 0 0 1-.899-.11c-.142-.127-.236-.332-.268-.568v-.174h.016z"
                                            fill="#000"
                                        />
                                        <path
                                            d="M53.844 22.691c.268-.331.536-.504.804-.504.031 0 .079 0 .142.015a.35.35 0 0 1 .173.08.604.604 0 0 1 .174.173c.047.079.094.189.11.315 0 .19-.047.41-.142.694-.094.284-.22.568-.394.883-.173.315-.363.646-.583.993a10.924 10.924 0 0 1-1.514 1.892c-.284.284-.552.52-.836.726l-.252.536c.11.047.205.126.236.268.048.142.095.284.142.442.048.157.11.3.205.425.095.127.253.19.473.19.142 0 .331-.08.568-.253.22-.173.473-.378.725-.63.253-.253.505-.52.757-.805.252-.283.457-.536.63-.756a.48.48 0 0 1 .127-.127.305.305 0 0 1 .158-.047c.047 0 .11.032.157.079.063.047.095.11.095.158 0 .047 0 .078-.016.126-.016.031-.032.079-.079.126-.016.016-.063.095-.173.236-.11.142-.252.316-.41.537-.174.204-.363.441-.584.678-.22.236-.441.473-.678.678a6.017 6.017 0 0 1-.677.52c-.221.142-.426.205-.615.205-.19 0-.331-.032-.458-.079a1.792 1.792 0 0 1-.3-.142 14.329 14.329 0 0 1-.299 1.956c-.157.662-.33 1.277-.552 1.829a6.37 6.37 0 0 1-.677 1.356c-.253.347-.49.536-.71.536-.41 0-.615-.331-.615-.978 0-.41.063-.883.173-1.419.11-.536.269-1.12.458-1.719.189-.615.41-1.245.662-1.908.252-.662.52-1.308.788-1.94.268-.63.552-1.245.836-1.828.284-.584.536-1.12.804-1.593.252-.473.489-.883.678-1.214.205-.347.378-.584.489-.71zm-4.226 12.316V35.306c.063 0 .142-.11.237-.315.11-.205.22-.489.33-.82.127-.331.237-.71.363-1.136.127-.425.237-.851.332-1.261.11-.426.189-.82.252-1.183.063-.378.095-.678.095-.914a.46.46 0 0 0-.032-.142c-.016-.047-.047-.095-.063-.142-.22.52-.41 1.04-.6 1.577-.188.52-.346 1.025-.488 1.514-.142.488-.252.946-.331 1.387-.047.41-.095.804-.095 1.136zm4.683-11.89c-.079.079-.173.22-.3.426-.126.205-.283.457-.441.757-.174.3-.347.63-.536 1.009-.19.378-.379.772-.584 1.182.332-.3.631-.646.9-1.024.267-.379.504-.757.677-1.12.19-.363.331-.678.426-.946.095-.268.142-.442.142-.52 0-.032 0-.032-.016-.032l-.268.268z"
                                            fill="#000"
                                        />
                                        <path
                                            d="M57.344 26.145c.19 0 .331.031.426.094.11.063.189.126.236.205a.554.554 0 0 1 .095.252c.016.095.016.158.016.221 0 .221-.08.442-.253.694a2.99 2.99 0 0 1-.662.678 5.214 5.214 0 0 1-.914.552 3.508 3.508 0 0 1-1.01.3c-.015.031-.015.078-.015.142 0 .063.016.141.031.22a.583.583 0 0 0 .11.221.67.67 0 0 0 .19.174.518.518 0 0 0 .268.063c.363 0 .741-.095 1.12-.3a6.39 6.39 0 0 0 1.087-.694c.347-.268.647-.536.899-.804.268-.268.457-.473.583-.63.063-.08.127-.143.19-.222.063-.063.126-.11.205-.11.094 0 .157.032.189.095a.448.448 0 0 1 .063.189c0 .047 0 .079-.016.095a.329.329 0 0 1-.063.094 8.675 8.675 0 0 1-1.072 1.198 8.341 8.341 0 0 1-1.151.915 6.309 6.309 0 0 1-1.088.6c-.347.141-.647.204-.899.204-.268 0-.489-.047-.646-.142a1.451 1.451 0 0 1-.41-.33 1.18 1.18 0 0 1-.205-.427c-.032-.157-.063-.3-.063-.425 0-.363.047-.678.142-.962.094-.284.22-.536.378-.773.158-.22.331-.426.536-.599.205-.174.394-.3.584-.41.189-.11.378-.205.536-.268.173-.063.3-.095.41-.126l.173.015zM56.083 27.5c-.11.11-.237.252-.363.41a2.282 2.282 0 0 0-.315.536 3.89 3.89 0 0 0 .693-.268c.253-.11.473-.253.678-.394.205-.142.379-.3.505-.442.126-.158.205-.3.205-.426 0-.079-.032-.126-.095-.126-.094 0-.252.047-.504.158-.237.126-.505.3-.804.552zM62.358 23.448c.142 0 .252.047.331.142.079.095.126.252.126.473 0 .237-.063.457-.19.662a2.403 2.403 0 0 1-.44.52 3.21 3.21 0 0 1-.505.348c-.158.079-.284.126-.347.126-.095 0-.142-.016-.173-.063-.032-.032-.032-.08-.032-.126 0-.08.079-.158.22-.253.064-.047.127-.094.19-.157.063-.064.142-.142.205-.221.063-.079.11-.174.158-.268a.823.823 0 0 0 .063-.331v-.064c0-.031-.016-.11-.032-.252 0-.142.032-.268.11-.378.064-.11.174-.158.316-.158zM5.786 25.672a2.685 2.685 0 0 0-.3-.3s-1.26-1.198-2.459-1.088c0 0-.646-.032-1.214.426.158.646.52 1.845 1.057 2.491.3.363.693.473 1.135.6.914.252 1.94.535 2.68 3.011.22-.3.363-.615.426-.915.189-.946-.032-2.743-1.293-4.178h-.032v-.047z"
                                            fill="#000"
                                        />
                                        <path
                                            d="M3.894 28.163c-.457-.126-.93-.268-1.324-.71-.536-.63-.883-1.718-1.072-2.412-.22.284-.426.662-.52 1.198-.379 2.019.882 4.273 2.806 5.156 1.135.52 2.018.253 2.586-.267-.678-2.46-1.64-2.729-2.476-2.965zM8.577 23.117c-.788.22-2.144.804-2.396 2.35.567.678 1.072 1.592 1.277 2.822 0 0 1.986-2.018 1.403-4.415a2.695 2.695 0 0 0-.284-.757z"
                                            fill="#000"
                                        />
                                        <path
                                            d="M8.356 22.802c-1.009-1.23-3.058-.868-4.682.946 0 0 1.15.33 2.191 1.387.379-1.45 1.656-2.081 2.491-2.333z"
                                            fill="#000"
                                        />
                                    </g>
                                    <defs>
                                        <clipPath id="6fss7756wa">
                                            <path
                                                fill="#fff"
                                                d="M0 0h66v36H0z"
                                            />
                                        </clipPath>
                                    </defs>
                                </svg>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </b-modal>

        <b-modal
            id="privilege_modal"
            modal-class=""
            centered
            hide-header
            hide-footer
            no-close-on-backdrop
            no-close-on-esc
        >
            <div class="modal-base">
                <div class="modal-base-head">
                    <p id="headline">{{ objSerialMessage.strHeadline }}</p>
                </div>
                <div class="modal-base-body">
                    <div class="serial-block">
                        <div
                            class="serial-wrapper"
                            v-if="
                                objSerialMessage.strMessageType === 'privilege'
                            "
                        >
                            <p
                                class="serial-privilege-message"
                                v-html="
                                    cleanMessage(
                                        this.objSerialMessage.strMessage
                                    )
                                "
                            ></p>
                            <p
                                class="serial-privilege-message"
                                v-if="campaign.derivered"
                            >
                                {{ lblSerial.delivery }}
                            </p>
                        </div>
                        <div
                            class="serial-wrapper"
                            v-if="
                                objSerialMessage.strMessageType === 'delivery'
                            "
                        >
                            <p
                                id="serial_draw_delivery"
                                class="serial-privilege-message"
                                v-html="
                                    cleanMessage(
                                        this.objSerialMessage.strMessage
                                    )
                                "
                            ></p>
                        </div>
                        <div class="serial-logo">
                            <img src="../../assets/buzzebees-logo-dark.svg" />
                        </div>
                    </div>
                </div>
                <div class="modal-base-footer"></div>
            </div>
        </b-modal>
    </div>
</template>
<script>
import Vue from "vue";
import Util from "@/helper/Utility.js";

import { SerialModel } from "@/core/Redeem/model/SerialModel.js";
import SerialHeader from "@/components/Modal/Redeem/Serial/Component/SerialHeader.vue";
import Moment from "moment";
import Locale from "@/helper/locale/locale.js";
import VueBarcode from "@chenfengyuan/vue-barcode"; // https://github.com/fengyuanchen/vue-barcode/blob/master/README.md
import VueQrcode from "@chenfengyuan/vue-qrcode"; // https://github.com/fengyuanchen/vue-qrcode
import VueClipboard from "vue-clipboard2";

/**
 * Property
 * @property {object} lbl (required) Text for component.
 * @property {object} busSerialModal (required) Modal Controller.
 * Event
 * @event clickChangeTab Change serial code type.
 * Method
 * @method initialSerialModal Setup serial modal with campaign.
 * @method closeSerialModal Stop interval and close modal.
 * Interval
 * @method startInterval Start serial interval.
 * @method stopInterval Stop serial interval.
 * @method serialExpired Set serial modal to expired state.
 * @method initialSerialTimer Setup time information and start interval.
 * @method timeFormatter Format timestamp to count down timer.
 * Utilities
 * @method cleanMessage Replace \n to <br/>
 * @method getRedeemDate Convert time stamp to readable format.
 * @method getDrawMessage Create message for campaign type draw.
 */
export default {
    name: "SerialModal",
    components: {
        VueBarcode,
        VueQrcode,
        SerialHeader,
    },
    props: {
        lbl: Object,
        busSerialModal: Object,
    },
    data: function () {
        return {
            campaign: {},
            lblDate: {},
            lblSerial: {},
            serial: null,

            interval: null,
            isTabLock: false,
            isRenderComplete: false,
            strSerialType: "serial", //serial,privilege
            objSerialMessage: {
                strHeadline: "",
                strMessage: "",
                strMessageType: "",
            },
            objSerialCode: {
                isShowCode: true,
                strCodeType: "", //CODE_128,QR_CODE,CODE
            },
            objTimer: {
                isExpired: false,
                isRunning: false,
                isShowTimer: false,
                numCurrentDate: "",
                numExpireDate: "",
                numExpireIn: 0,
                numOriginalDate: 0,
                strTimeLeft: "",
            },
            objBarcodeConfig: {
                height: 50,
                width: 0.5,
                displayValue: false,
                lineColor: "#000000",
            },
            objQrCodeConfig: {
                width: 160,
                margin: 0,
            },
        };
    },
    created: function () {
        ///initial copy plugin///
        VueClipboard.config.autoSetContainer = true;
        Vue.use(VueClipboard);
    },
    mounted: function () {
        this.lblDate = this.lbl.date;
        this.lblSerial = this.lbl.serial;
        this.busSerialModal.$on("showSerialModal", this.initialSerialModal);
        this.busSerialModal.$on("hideSerialModal", this.closeSerialModal);
    },
    methods: {
        //Event
        clickChangeTab: function (strCurrentTab) {
            if (this.isTabLock) return;

            this.objSerialCode.strCodeType = strCurrentTab;
        },
        //End Event
        //Function
        initialSerialModal: function (campaign) {
            this.campaign = Util.normalObject(campaign);
            // console.log('this', this.campaign)
            //Clear interval
            this.serial = new SerialModel();
            this.serial.setModelFromDataModel(this.campaign);
            if (this.interval) this.stopInterval();

            if (
                this.campaign.delivered === true ||
                this.campaign.type === Vue.CampaignType.Draw
            )
                this.strSerialType = "draw_or_delivery";

            //Initial modal type
            switch (this.strSerialType) {
                case "serial":
                    //Initial serial tab
                    console.log(this.campaign.barcode);
                    switch (this.campaign.barcode) {
                        case "CODE_128":
                            this.objSerialCode.strCodeType = "CODE_128";
                            break;
                        case "QR_CODE":
                            this.objSerialCode.strCodeType = "QR_CODE";
                            break;
                        default:
                            if (
                                this.campaign.barcode.toLowerCase() ===
                                    "none" &&
                                this.campaign.privilegeMessage
                            )
                                this.objSerialCode.isShowCode = false;

                            this.objSerialCode.strCodeType = "QR_CODE";
                            break;
                    }

                    //Set privilege message fonmat
                    if (
                        this.campaign.privilegeMessageFormat &&
                        this.campaign.privilegeMessageFormat.toLowerCase() ===
                            "html"
                    ) {
                        if (this.campaign.privilegeMessage)
                            this.objSerialMessage.strMessage =
                                this.campaign.privilegeMessage;
                    } else {
                        if (this.campaign.privilegeMessage)
                            this.objSerialMessage.strMessage =
                                this.campaign.privilegeMessage;
                        else
                            this.objSerialMessage.strMessage =
                                this.lblSerial.show_code_at_shop;
                    }

                    //Set isShowTimer
                    this.initialSerialTimer();

                    this.$bvModal.show("serial_modal");
                    break;
                case "draw_or_delivery":
                    if (this.campaign.privilegeMessage) {
                        this.objSerialMessage.strMessage =
                            this.campaign.privilegeMessage;
                        this.objSerialMessage.strMessageType = "privilege";
                    } else {
                        if (this.campaign.delivered === true) {
                            this.objSerialMessage.strMessage =
                                this.lblSerial.delivery;
                            this.objSerialMessage.strMessageType = "delivery";
                        }

                        if (this.campaign.type === Vue.CampaignType.Draw) {
                            this.objSerialMessage.strMessage =
                                this.getDrawMessage(this.lblSerial.draw);
                            this.objSerialMessage.strMessageType = "privilege";
                        }
                    }

                    this.$bvModal.show("privilege_modal");
                    break;
            }
        },
        closeSerialModal: function () {
            switch (this.strSerialType) {
                case "serial":
                    this.stopInterval();
                    this.$bvModal.hide("serial_modal");
                    break;
                case "draw_or_delivery":
                    this.$bvModal.hide("privilege_modal");
                    break;
            }
        },
        //Timer
        startInterval: function () {
            var self = this;
            this.timeFormatter(false, true, ":");
            this.interval = setInterval(function () {
                self.timeFormatter(false, true, ":");
            }, 1000);
        },
        stopInterval: function () {
            clearInterval(this.interval);
        },
        onCopyCode: function (e) {
            console.log("copied", e.text);
        },
        onErrorCode: function (e) {
            console.log("failed", e);
        },
        serialExpired: function () {
            this.objSerialCode.strCodeType = "CODE";
            this.isTabLock = true;
            this.objTimer.isExpired = true;
            this.objTimer.isRunning = false;
            this.campaign.serial = "XXXXXXX";
            this.campaign.expireIn = -1;

            this.stopInterval();

            this.$emit("serialExpired", {});
        },
        initialSerialTimer: function () {
            if (this.campaign.expireIn && this.campaign.expireIn !== null) {
                this.objTimer.isShowTimer = true;
                this.objTimer.numCurrentDate = this.campaign.currentDate;
                this.objTimer.numOriginalDate = this.campaign.currentDate;
                this.objTimer.numExpireDate =
                    this.campaign.currentDate + this.campaign.expireIn;
                this.objTimer.numExpireIn = this.campaign.expireIn;
                this.startInterval();
            }
            if (this.campaign.expireIn === null) {
                this.objTimer.isShowTimer = false;
            }
        },
        timeFormatter: function (isShowDay, isShowHour, strSeparator) {
            var numTimeDiff =
                Moment.unix(this.objTimer.numExpireDate) -
                Moment.unix(this.objTimer.numCurrentDate);
            //Timer Expired
            if (numTimeDiff <= 0) {
                numTimeDiff = 0;
                this.serialExpired();
            }

            //Add 1 second to current date.
            this.objTimer.numCurrentDate++;

            //Calculate day.
            var numDayDiff = Math.floor(numTimeDiff / 1000 / 60 / 60 / 24);
            var haveDay = parseInt(numDayDiff) <= 0 ? false : true;
            if (isShowDay) numTimeDiff -= numDayDiff * 1000 * 60 * 60 * 24;

            //Calculate hour.
            var numHourDiff = Math.floor(numTimeDiff / 1000 / 60 / 60);
            var haveHour = parseInt(numHourDiff) <= 0 ? false : true;
            if (isShowHour) numTimeDiff -= numHourDiff * 1000 * 60 * 60;

            if (numHourDiff <= 9) numHourDiff = "0" + numHourDiff;

            //Calculate minute.
            var numMinuteDiff = Math.floor(numTimeDiff / 1000 / 60);
            var haveMinute = parseInt(numMinuteDiff) <= 0 ? false : true;
            numTimeDiff -= numMinuteDiff * 1000 * 60;

            if (numMinuteDiff <= 9) numMinuteDiff = "0" + numMinuteDiff;

            //Calculate second.
            var numSecondDiff = "" + Math.floor(numTimeDiff / 1000);
            var haveSecond = parseInt(numSecondDiff) <= 0 ? false : true;
            if (numSecondDiff <= 9) numSecondDiff = "0" + numSecondDiff;

            var strTimeLeft = "";
            if (isShowDay) {
                if (haveDay) var message = this.lblSerial.redeem_on2;
                var result = Moment.unix(this.objTimer.numExpireDate).utc();
                var year = Moment.unix(this.objTimer.numExpireDate)
                    .utc()
                    .format("YYYY");
                if (Locale.getLocaleCode() === 1054)
                    year = result.get("year") + 543;

                //for 2 digits.
                let showYear = year.toString().substring(2, 4);

                var monthString =
                    this.lblDate.month_short[result.format("M") - 1];
                var strDate =
                    result.format("DD") + " " + monthString + " " + showYear;

                strTimeLeft = Util.stringFormat(message, strDate);

                console.log("strTimeLeft", strTimeLeft);

                isShowHour = false;
                haveMinute = false;
                haveSecond = false;
            }

            if (isShowHour) {
                if (haveHour) strTimeLeft += numHourDiff + strSeparator;
                else if (haveSecond && !haveDay)
                    strTimeLeft += "00" + strSeparator;
            }

            //Always show minute.
            if (haveMinute) strTimeLeft += numMinuteDiff + strSeparator;
            else if (haveSecond && !haveDay) strTimeLeft += "00" + strSeparator;

            //Always show second.
            if (haveSecond) strTimeLeft += numSecondDiff;
            else if (haveSecond && !haveDay) strTimeLeft += "00";

            this.objTimer.strTimeLeft = strTimeLeft;
        },
        //Utility
        cleanMessage: function (message) {
            return Util.newLineToBr(message);
        },
        getRedeemDate: function (redeemDate) {
            if (!redeemDate) return;

            var message = this.lblSerial.redeem_on2;
            var result = Moment.unix(redeemDate).utc();
            var year = Moment.unix(redeemDate).utc().format("YYYY");
            if (Locale.getLocaleCode() === 1054)
                year = result.get("year") + 543;

            //for 2 digits.
            let showYear = year.toString().substring(2, 4);

            // var monthString = this.lblDate.month_short[result.format("M") - 1];
            var monthString = result.format("MM");

            var strDate =
                result.format("DD") +
                "/" +
                monthString +
                "/" +
                showYear +
                " - " +
                result.format("HH:mm");

            return Util.stringFormat(message, strDate);
        },
        getDrawMessage: function (message) {
            var expireDate = this.campaign.expireDate;
            var result = Moment.unix(expireDate).utc();
            var year = Moment.unix(expireDate).utc().format("YYYY");
            if (Locale.getLocaleCode() === 1054)
                year = result.get("year") + 543;

            var monthString = this.lblDate.month_short[result.format("M") - 1];
            var strDate =
                result.format("DD") +
                " " +
                monthString +
                " " +
                year +
                " | " +
                result.format("HH:mm");

            return Util.stringFormat(message, strDate);
        },
    },
};
</script>
<style lang="scss" scoped>
@import "@/style/base/base.scss";
@import "./SerialModal.scss";
.modal-base-close {
    margin: 20px;
}
</style>
